import { ACK_MESSAGE, FIN_MESSAGE, FIN_SERVER_MESSAGE, SYN_ACK_MESSAGE, SYN_MESSAGE, SYN_SERVER_MESSAGE } from '../../internal/rpc-handshake/constants';
const HANDSHAKE_MESSAGES = [
    SYN_MESSAGE,
    SYN_SERVER_MESSAGE,
    SYN_ACK_MESSAGE,
    ACK_MESSAGE,
    FIN_SERVER_MESSAGE,
    FIN_MESSAGE
];
function isHandshakeEvent(namespace, event) {
    return event !== null && typeof event === 'object' && typeof event.message === 'string' && typeof event.namespace === 'string' && event.namespace === namespace && HANDSHAKE_MESSAGES.includes(event.message);
}
export function createRpcHandshake(namespace) {
    return {
        syn: (transport, data, transfer)=>{
            const event = {
                namespace,
                message: SYN_MESSAGE,
                data
            };
            transport.postMessage(event, transfer);
        },
        synServer: (transport, data, transfer)=>{
            const event = {
                namespace,
                message: SYN_SERVER_MESSAGE,
                data
            };
            transport.postMessage(event, transfer);
        },
        synAck: (transport, data, transfer)=>{
            const event = {
                namespace,
                message: SYN_ACK_MESSAGE,
                data
            };
            transport.postMessage(event, transfer);
        },
        ack: (transport, data, transfer)=>{
            const event = {
                namespace,
                message: ACK_MESSAGE,
                data
            };
            transport.postMessage(event, transfer);
        },
        fin: (transport, data, transfer)=>{
            const event = {
                namespace,
                message: FIN_MESSAGE,
                data
            };
            transport.postMessage(event, transfer);
        },
        finServer: (transport, data, transfer)=>{
            const event = {
                namespace,
                message: FIN_SERVER_MESSAGE,
                data
            };
            transport.postMessage(event, transfer);
        },
        isSynEvent: (event)=>{
            return isHandshakeEvent(namespace, event) && event.message === SYN_MESSAGE;
        },
        isSynServerEvent: (event)=>{
            return isHandshakeEvent(namespace, event) && event.message === SYN_SERVER_MESSAGE;
        },
        isSynAckEvent: (event)=>{
            return isHandshakeEvent(namespace, event) && event.message === SYN_ACK_MESSAGE;
        },
        isAckEvent: (event)=>{
            return isHandshakeEvent(namespace, event) && event.message === ACK_MESSAGE;
        },
        isFinEvent: (event)=>{
            return isHandshakeEvent(namespace, event) && event.message === FIN_MESSAGE;
        },
        isFinServerEvent: (event)=>{
            return isHandshakeEvent(namespace, event) && event.message === FIN_SERVER_MESSAGE;
        }
    };
}

//# sourceMappingURL=handshake.js.map